import React from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faClose } from '@fortawesome/pro-regular-svg-icons'

const HamburgerIconButton = styled.button(({theme}) => ({
	all: 'unset',
	cursor: 'pointer',
	width: theme.spacing(3),
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	fontSize: '18px',
}))

interface L1HamburgerProps {
	open: boolean
	onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const L1Hamburger = ({open, onClick}: L1HamburgerProps) => {
	return (
		<HamburgerIconButton onClick={onClick}>
			<FontAwesomeIcon fixedWidth icon={open ? faClose : faBars} />
		</HamburgerIconButton>
	)
}

export default L1Hamburger
